import styled, { css } from "styled-components";

import { Form, Upload } from "antd";

export const Container = styled(Form.Item)`
  width: 100%;
  height: 68px;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;

  .ant-form-item-label {
    padding: 0 0 5px !important;
  }

  .ant-form-item-label > label {
    color: #444;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;

    svg {
      cursor: pointer !important;
      margin-left: 5px;
    }
  }
`;

export const CustomDragger = styled(Upload.Dragger)`

`;


